import { createFileRoute } from "@tanstack/react-router";
import { ContractSettlementMonthlyPage } from "@/features/contracts/contract-settlement-monthly-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/$id/miesiecznie")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractSettlementMonthlyPage,
});
